var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-progress-bar progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-custom active",style:(_vm.progressStyle),attrs:{"role":"progressbar","aria-valuenow":"10","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._v("45% Complete")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }